import styled from 'styled-components';

import MenuLayoutComponent from '../../../layout-components/menu';

const MenuContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  padding: 0 10px 0px 10px;
  margin-top: 10px;
  margin-bottom: 23px;
`;

const Menu = styled(MenuLayoutComponent)``;
const Item = styled(MenuLayoutComponent.Item)``;

export {
  Menu,
  MenuContainer,
  Item,
};
